type TFormsBlockWrapper = {
  children: React.ReactNode;
};

const FormBlockWrapper = ({ children }: TFormsBlockWrapper) => {
  return <section className={`max-width padded-sides centered mb-lg`}>{children}</section>;
};

export default FormBlockWrapper;
